export default "__VITE_ASSET__B1M1dQgB__"